export default "__VITE_ASSET__Dad_5c6Q__"